const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : MicrophoneController
 */

function MicrophoneController(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

MicrophoneController.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('MicrophoneController');
  const _initial_MicrophoneController_MicrophoneController = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const MicrophoneController_MicrophoneController_Init = new StateJS.State('Init', this._statemachine).entry(() => {
    this.registerSimpleAudioWorklet();
  });
  const MicrophoneController_MicrophoneController_Muted = new StateJS.State('Muted', this._statemachine).entry(() => {
    console.log('THINGML_> MUTED');
    this.microphoneStatus(true);
    this.MicrophoneController_audioMessageBuffer_var = new Uint8Array();
  });
  const MicrophoneController_MicrophoneController_PlayStartTone = new StateJS.State('PlayStartTone', this._statemachine).entry(() => {
    console.log('THINGML_> PLAY START TONE');
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var, this.MicrophoneController_startToneTimeout_var + 100));
    this.generatePleasantTone(false);
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var));
  });
  const MicrophoneController_MicrophoneController_Unmuted = new StateJS.State('Unmuted', this._statemachine).entry(() => {
    console.log('THINGML_> UNMUTED');
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var, this.MicrophoneController_maxRecordingTime_var));
    // Ask for microphone access and stream audio with 8kHz sampling (direct G.711 compatibility)
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      try {
        console.log('Microphone access granted!');
        this.MicrophoneController_stream_var = stream;
        this.microphoneStatus(false);
        // Check if we're actually getting audio tracks
        const audioTracks = stream.getAudioTracks();
        console.log('Audio tracks:', audioTracks.length);
        if (audioTracks.length === 0) {
          throw new Error('No audio tracks in media stream');
        }

        // Log track settings for debugging
        const settings = audioTracks[0].getSettings();
        console.log('Audio track settings:', settings);

        // Create audio context
        this.MicrophoneController_audioContext_var = new AudioContext();
        console.log('Audio context sample rate:', this.MicrophoneController_audioContext_var.sampleRate);

        // Register the audio worklet
        console.log('Registering audio worklet from URL:', this.MicrophoneController_workletUrl_var);
        this.MicrophoneController_audioContext_var.audioWorklet.addModule(this.MicrophoneController_workletUrl_var).then(() => {
          console.log('AudioWorklet module loaded successfully');

          // Create the audio source
          const source = this.MicrophoneController_audioContext_var.createMediaStreamSource(stream);
          console.log('MediaStreamSource created');

          // Create the processor node with appropriate options
          const processor = new AudioWorkletNode(this.MicrophoneController_audioContext_var, 'simple-audio-processor', {
            numberOfInputs: 1,
            numberOfOutputs: 1,
            channelCount: 1,
            processorOptions: {
              bufferTimeMs: this.MicrophoneController_bufferTimeInMs_var,
            },
          });

          console.log('AudioWorkletNode created');

          // Set up message handling for audio data
          processor.port.onmessage = (event) => {
            // Handle audio data
            if (event.data && event.data.buffer) {
              try {
                // Use Uint8Array for G.711 μ-law data (1 byte per sample)
                const audioBuffer = new Uint8Array(event.data.buffer);

                console.log('Audio data received! Length:', audioBuffer.length);

                // Since audioBuffer already contains G.711 μ-law data,
                // we can append it directly to our buffer using helper function
                this.appendToBuffer(audioBuffer, 'G.711 μ-law audio');
                // Check if the buffer is getting too large (limit to ~1MB to prevent memory issues)
                if ((this.MicrophoneController_audioMessageBuffer_var).length > this.MicrophoneController_MAX_BUFFER_SIZE_var) {
                  this.bus.emit('microphone', new Event.ForwardAudio_MicrophoneControl(this.name, 'microphone'));
                  return;
                }
              } catch (error) {
                console.error('Error processing audio data:', error);
              }
            } else {
              console.error('Received malformed audio data:', event.data);
            }
          };

          // Add error handler
          processor.onprocessorerror = (err) => {
            console.error('AudioWorklet processing error:', err);
          };

          // Connect the audio processing pipeline
          source.connect(processor);

          console.log('Audio processing pipeline established');

          // Store references for cleanup
          this.MicrophoneController_audioProcessor_var = processor;
          this.MicrophoneController_audioSource_var = source;
        }).catch((error) => {
          console.error('Error loading AudioWorklet:', error);
        });
      } catch (error) {
        console.error('Error creating audio processing pipeline:', error);

        // Attempt cleanup of partial setup
        if (this.MicrophoneController_stream_var) {
          for (const track of this.MicrophoneController_stream_var.getTracks()) track.stop();
          this.MicrophoneController_stream_var = null;
        }

        if (this.MicrophoneController_audioContext_var) {
          this.MicrophoneController_audioContext_var.close().catch((error_) => console.error('Error closing AudioContext:', error_));
          this.MicrophoneController_audioContext_var = null;
        }
      }
    }).catch((error) => {
      console.error('Microphone access denied:', error);
    });
  }).exit(() => {
    this.microphoneStatus(true);
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var));
    this.cleanup();
  });
  const MicrophoneController_MicrophoneController_PlayClosingTone = new StateJS.State('PlayClosingTone', this._statemachine).entry(() => {
    console.log('THINGML_> PLAY CLOSING TONE');
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var, this.MicrophoneController_closingToneTimeout_var + 100));
    this.generatePleasantTone(true);
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.MicrophoneController_timerId_var));
  });
  const MicrophoneController_MicrophoneController_HashAudio = new StateJS.State('HashAudio', this._statemachine).entry(() => {
    this.computeBufferHash(this.MicrophoneController_audioMessageBuffer_var);
  });
  const MicrophoneController_MicrophoneController_ForwardAudio = new StateJS.State('ForwardAudio', this._statemachine).entry(() => {
    this.MicrophoneController_client_var.audioForwardingToken(this.MicrophoneController_cameraId_var, this.MicrophoneController_audioHash_var).then((token) => {
      const url_var = `${this.MicrophoneController_apiURL_var}/${this.MicrophoneController_serial_var}`;
      const authHeader_var = `Basic ${token}`;
      fetch(url_var, {
        method: 'POST',
        headers: {
          'Content-Type': 'audio/basic',
          Authorization: authHeader_var,
        },
        body: this.MicrophoneController_audioMessageBuffer_var, // Send just the audio data when using fetch (headers added automatically)
      }).then((response) => {
        if (response.ok) {
          this.bus.emit('microphone', new Event.AudioForwarded_MicrophoneControl(this.name, 'microphone'));
        } else {
          this.bus.emit('microphone', new Event.AudioForwardingFailed_MicrophoneControl(this.name, 'microphone'));
        }
      }).catch((error) => {
        this.bus.emit('microphone', new Event.AudioForwardingFailed_MicrophoneControl(this.name, 'microphone'));
        console.error(error);
      });
    }, (error) => {
      this.bus.emit('microphone', new Event.AudioForwardingFailed_MicrophoneControl(this.name, 'microphone'));
      console.error(error);
    });
  });
  const MicrophoneController_MicrophoneController_Final = new StateJS.State('Final', this._statemachine).entry(() => {
    console.log('THINGML_> FINAL');
    this.cleanup();
    if ((this.MicrophoneController_workletUrl_var != null)) {
      URL.revokeObjectURL(this.MicrophoneController_workletUrl_var);
    }
    setImmediate(() => this._stop());
  });
  _initial_MicrophoneController_MicrophoneController.to(MicrophoneController_MicrophoneController_Init);
  MicrophoneController_MicrophoneController_Init.to(MicrophoneController_MicrophoneController_Muted);
  MicrophoneController_MicrophoneController_PlayClosingTone.to(MicrophoneController_MicrophoneController_HashAudio).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.MicrophoneController_timerId_var));
  MicrophoneController_MicrophoneController_PlayStartTone.to(MicrophoneController_MicrophoneController_Unmuted).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.MicrophoneController_timerId_var));
  MicrophoneController_MicrophoneController_Unmuted.to(MicrophoneController_MicrophoneController_PlayClosingTone).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.MicrophoneController_timerId_var));
  MicrophoneController_MicrophoneController_Muted.to(MicrophoneController_MicrophoneController_PlayStartTone).on(Event.Toggle_MicrophoneControl).when((toggle) => toggle.port === 'microphone' && toggle.type === 'toggle');
  MicrophoneController_MicrophoneController_Unmuted.to(MicrophoneController_MicrophoneController_PlayClosingTone).on(Event.Toggle_MicrophoneControl).when((toggle) => toggle.port === 'microphone' && toggle.type === 'toggle');
  MicrophoneController_MicrophoneController_ForwardAudio.to(MicrophoneController_MicrophoneController_Muted).on(Event.AudioForwardingFailed_MicrophoneControl).when((audioForwardingFailed) => audioForwardingFailed.port === 'microphone' && audioForwardingFailed.type === 'audioForwardingFailed').effect((audioForwardingFailed) => {
    this.audioForwarded(false);
  });
  MicrophoneController_MicrophoneController_Muted.to(MicrophoneController_MicrophoneController_Final).on(Event.Terminate_MicrophoneControl).when((terminate) => terminate.port === 'microphone' && terminate.type === 'terminate');
  MicrophoneController_MicrophoneController_PlayClosingTone.to(MicrophoneController_MicrophoneController_Final).on(Event.Terminate_MicrophoneControl).when((terminate) => terminate.port === 'microphone' && terminate.type === 'terminate');
  MicrophoneController_MicrophoneController_PlayStartTone.to(MicrophoneController_MicrophoneController_Final).on(Event.Terminate_MicrophoneControl).when((terminate) => terminate.port === 'microphone' && terminate.type === 'terminate');
  MicrophoneController_MicrophoneController_HashAudio.to(MicrophoneController_MicrophoneController_Final).on(Event.Terminate_MicrophoneControl).when((terminate) => terminate.port === 'microphone' && terminate.type === 'terminate');
  MicrophoneController_MicrophoneController_Unmuted.to(MicrophoneController_MicrophoneController_Final).on(Event.Terminate_MicrophoneControl).when((terminate) => terminate.port === 'microphone' && terminate.type === 'terminate');
  MicrophoneController_MicrophoneController_ForwardAudio.to(MicrophoneController_MicrophoneController_Muted).on(Event.AudioForwarded_MicrophoneControl).when((audioForwarded) => audioForwarded.port === 'microphone' && audioForwarded.type === 'audioForwarded').effect((audioForwarded) => {
    this.audioForwarded(true);
  });
  MicrophoneController_MicrophoneController_HashAudio.to(MicrophoneController_MicrophoneController_ForwardAudio).on(Event.AudioHash_MicrophoneControl).when((audioHash) => audioHash.port === 'microphone' && audioHash.type === 'audioHash').effect((audioHash) => {
    this.MicrophoneController_audioHash_var = audioHash.hash;
  });
  MicrophoneController_MicrophoneController_Unmuted.to(MicrophoneController_MicrophoneController_PlayClosingTone).on(Event.ForwardAudio_MicrophoneControl).when((forwardAudio) => forwardAudio.port === 'microphone' && forwardAudio.type === 'forwardAudio');
};
MicrophoneController.prototype.audioForwarded = function (MicrophoneController_audioForwarded_success_var) {};

MicrophoneController.prototype.microphoneStatus = function (MicrophoneController_microphoneStatus_isMuted_var) {};

MicrophoneController.prototype.setToneVolume = function (MicrophoneController_setToneVolume_value_var) {
  this.MicrophoneController_toneVolume_var = MicrophoneController_setToneVolume_value_var;
};

MicrophoneController.prototype.getToneVolume = function () {
  return this.MicrophoneController_toneVolume_var;
};

MicrophoneController.prototype.touch = function () {
  console.log('THINGML_> microphone.touch');
  this.bus.emit('microphone', new Event.Toggle_MicrophoneControl(this.name, 'microphone'));
};

MicrophoneController.prototype.terminate = function () {
  console.log('THINGML_> microphone.terminate');
  this.bus.emit('microphone', new Event.Terminate_MicrophoneControl(this.name, 'microphone'));
};

MicrophoneController.prototype.linearToMulaw = function (MicrophoneController_linearToMulaw_scaledSample_var) {
  // Exact implementation matching the external library with proper variable names
  let sample = Math.round(MicrophoneController_linearToMulaw_scaledSample_var);

  // Extract sign bit and make sample positive if negative
  const signBit = sample >> 8 & 128; // Extract sign bit (0x80 if negative)
  if (signBit !== 0) {
    sample = -sample; // Convert negative to positive magnitude
  }

  // Apply clipping (their CLIP constant = 32635)
  if (sample > 32635) sample = 32635;

  // Add bias (their BIAS constant = 132)
  sample += 132;

  // Their exact EXPONENT_LOOKUP table (256 entries)
  const exponentLookup = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];

  // Get exponent (segment) from lookup table
  const exponent = exponentLookup[(sample >> 7) & 255];

  // Calculate mantissa (quantization level within segment)
  const mantissa = (sample >> (exponent + 3)) & 15;

  // Combine sign, exponent, and mantissa, then invert (μ-law standard)
  return ~(signBit | (exponent << 4) | mantissa);
};

MicrophoneController.prototype.appendToBuffer = function (MicrophoneController_appendToBuffer_newData_var, MicrophoneController_appendToBuffer_description_var) {
  const existingBuffer = this.MicrophoneController_audioMessageBuffer_var;
  const combinedBuffer = new Uint8Array(existingBuffer.length + MicrophoneController_appendToBuffer_newData_var.length);
  combinedBuffer.set(existingBuffer, 0);
  combinedBuffer.set(MicrophoneController_appendToBuffer_newData_var, existingBuffer.length);
  this.MicrophoneController_audioMessageBuffer_var = combinedBuffer;

  console.log(`Buffered ${MicrophoneController_appendToBuffer_description_var}: ${MicrophoneController_appendToBuffer_newData_var.length
  } bytes, total buffer size: ${combinedBuffer.length} bytes`);
};

MicrophoneController.prototype.cleanup = function () {
  if ((this.MicrophoneController_audioProcessor_var != null)) {
    try {
      console.log('Disconnecting AudioWorkletNode');
      this.MicrophoneController_audioProcessor_var.port.postMessage({ type: 'cleanup' });
      this.MicrophoneController_audioProcessor_var.disconnect();
    } catch (error) {
      console.error('Error disconnecting audio processor:', error);
    }
    this.MicrophoneController_audioProcessor_var = null;
  }
  if ((this.MicrophoneController_audioSource_var != null)) {
    try {
      console.log('Disconnecting MediaStreamAudioSourceNode');
      this.MicrophoneController_audioSource_var.disconnect();
    } catch (error) {
      console.error('Error disconnecting audio source:', error);
    }
    this.MicrophoneController_audioSource_var = null;
  }
  if ((this.MicrophoneController_audioContext_var != null)) {
    try {
      console.log('Closing AudioContext');
      this.MicrophoneController_audioContext_var.close();
    } catch (error) {
      console.error('Error closing audio context:', error);
    }
    this.MicrophoneController_audioContext_var = null;
  }
  if ((this.MicrophoneController_stream_var != null)) {
    /* eslint-disable no-restricted-syntax */
    console.log('Stopping media tracks');
    for (const track of this.MicrophoneController_stream_var.getTracks()) {
      try {
        track.stop();
      } catch (error) {
        console.error('Error stopping media track:', error);
      }
    }
    this.MicrophoneController_stream_var = null;
  }
};

MicrophoneController.prototype.createToneParameters = function (MicrophoneController_createToneParameters_isTermination_var) {
  return ({
    notes: MicrophoneController_createToneParameters_isTermination_var ? ['F3', 'D3', 'C3'] : ['C5', 'E5', 'G5'], // Calming descending progression to terminate, Welcoming ascending chord to start
    noteDuration: '4n',
    volume: -20 + (this.MicrophoneController_toneVolume_var * 20), // -20dB to 0dB range
    envelope: {
      attack: 0.02, decay: 0.1, sustain: 0.3, release: 0.5,
    },
    cleanupDelayMs: this.MicrophoneController_startToneTimeout_var,
  });
};

MicrophoneController.prototype.createToneSequence = function (MicrophoneController_createToneSequence_params_var) {
  // Create a new Tone.js synth with medical-optimized envelope
  const synth = new this.MicrophoneController_tone_var.Synth({
    oscillator: { type: 'triangle' },
    envelope: MicrophoneController_createToneSequence_params_var.envelope,
  }).toDestination();

  // Set volume
  synth.volume.value = MicrophoneController_createToneSequence_params_var.volume;
  return synth;
};

MicrophoneController.prototype.renderToneToBuffer = function (MicrophoneController_renderToneToBuffer_isTermination_var) {
  const params = this.createToneParameters(MicrophoneController_renderToneToBuffer_isTermination_var);

  // Use Tone.js offline rendering at 8kHz for direct G.711 compatibility
  return (this.MicrophoneController_tone_var.Offline(({ transport }) => {
    const synth = this.createToneSequence(params);

    // Play the note sequence
    for (const [index, note] of params.notes.entries()) {
      const time = index * 0.6; // 0.6 seconds between notes
      synth.triggerAttackRelease(note, params.noteDuration, time);
    }
  }, 2, 1, 16000));
};

MicrophoneController.prototype.processRenderedBuffer = function (MicrophoneController_processRenderedBuffer_renderedBuffer_var) {
  // Get audio data at 16kHz
  const audioData16k = MicrophoneController_processRenderedBuffer_renderedBuffer_var.getChannelData(0);

  // Downsample from 16kHz to 8kHz (match worklet approach)
  const audioData8k = new Float32Array(Math.floor(audioData16k.length / 2));
  for (let i = 0; i < audioData8k.length; i++) {
    audioData8k[i] = audioData16k[i * 2]; // Skip every other sample
  }

  // Convert 8kHz samples to G.711 μ-law using speech-optimized scaling
  const g711Buffer = new Uint8Array(audioData8k.length);
  for (const [i, element] of audioData8k.entries()) {
    // Use same conservative scaling as the worklet (24000 instead of 36863)
    g711Buffer[i] = this.linearToMulaw((24000 * element));
  }
  this.appendToBuffer(g711Buffer, 'tone as G.711 μ-law');
};

MicrophoneController.prototype.generatePleasantTone = function (MicrophoneController_generatePleasantTone_isTermination_var) {
  const params = this.createToneParameters(MicrophoneController_generatePleasantTone_isTermination_var);

  // Clean up previous tone
  if (this.MicrophoneController_toneGenerator_var) {
    try {
      this.MicrophoneController_toneGenerator_var.dispose();
    } catch (error) {
      console.error('Error cleaning up previous tone:', error);
    }
  }

  // Create and play tone sequence for local speaker
  const synth = this.createToneSequence(params);

  // Play the note sequence
  for (const [index, note] of params.notes.entries()) {
    const time = this.MicrophoneController_tone_var.now() + (index * 0.6); // 0.6 seconds between notes
    synth.triggerAttackRelease(note, params.noteDuration, time);
  }

  // Store reference for cleanup
  this.MicrophoneController_toneGenerator_var = synth;

  // Render same melody to buffer for transmission
  this.renderToneToBuffer(MicrophoneController_generatePleasantTone_isTermination_var).then((renderedBuffer) => {
    this.processRenderedBuffer(renderedBuffer);
  }).catch((error) => {
    console.error('Error rendering tone:', error);
  });

  // Schedule cleanup
  setTimeout(() => {
    if (this.MicrophoneController_toneGenerator_var) {
      try {
        this.MicrophoneController_toneGenerator_var.dispose();
        this.MicrophoneController_toneGenerator_var = null;
      } catch (error) {
        console.error('Error cleaning up tone generator:', error);
      }
    }
  }, params.cleanupDelayMs);
};

MicrophoneController.prototype.workletProcessorCode = function () {
  return (`${'class AudioProcessor extends AudioWorkletProcessor {\n'
        + '  constructor() {\n'
        + '    super();\n'
        + '    this.audioBuffer = [];\n'
        + '    this.lastSentTime = currentTime;\n'
        + '    this.sendIntervalMs = '}${this.MicrophoneController_bufferTimeInMs_var};\n`
        + '    \n'
        + '    // Optimize for speech: direct 8kHz processing\n'
        + '    this.inputSampleRate = sampleRate;\n'
        + '    this.targetSampleRate = 8000;  // Direct to G.711 sample rate\n'
        + '    this.resampleRatio = this.inputSampleRate / this.targetSampleRate;\n'
        + '    this.needsResampling = this.inputSampleRate !== this.targetSampleRate;\n'
        + '    \n'
        + '    // Initialize speech-optimized pre-emphasis filter\n'
        + '    this.preEmphasisAlpha = 0.97;  // Standard speech pre-emphasis\n'
        + '    this.prevSample = 0;\n'
        + '    \n'
        + '    // Initialize speech-optimized automatic gain control\n'
        + '    this.agcTarget = 0.25;  // Target RMS level\n'
        + '    this.agcGain = 1.0;\n'
        + '    this.agcSmoothingFactor = 0.995;\n'
        + '    \n'
        + '    console.log(\'Speech-optimized AudioWorklet initialized:\', this.inputSampleRate, \'Hz → 8kHz, ratio:\', this.resampleRatio);\n'
        + '  }\n'
        + '  \n'
        + '  // ⚠️ SYNC WARNING: Keep this function in sync with linearToMulaw() in ThingML\n'
        + '  // Optimized G.711 μ-law encoding for speech\n'
        + '  linearToMulaw(scaledSample) {\n'
        + '    let sample = Math.round(scaledSample);\n'
        + '    \n'
        + '    // Extract sign bit and make sample positive if negative\n'
        + '    const signBit = sample >> 8 & 128;  // Extract sign bit (0x80 if negative)\n'
        + '    if (signBit !== 0) {\n'
        + '        sample = -sample;  // Convert negative to positive magnitude\n'
        + '    }\n'
        + '    \n'
        + '    // Apply clipping (their CLIP constant = 32635)\n'
        + '    if (sample > 32635) sample = 32635;\n'
        + '    \n'
        + '    // Add bias (their BIAS constant = 132)\n'
        + '    sample += 132;\n'
        + '    \n'
        + '    // Their exact EXPONENT_LOOKUP table (256 entries)\n'
        + '    const exponentLookup = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];\n'
        + '    \n'
        + '    // Get exponent (segment) from lookup table\n'
        + '    const exponent = exponentLookup[(sample >> 7) & 255];\n'
        + '    \n'
        + '    // Calculate mantissa (quantization level within segment)\n'
        + '    const mantissa = (sample >> (exponent + 3)) & 15;\n'
        + '    \n'
        + '    // Combine sign, exponent, and mantissa, then invert (μ-law standard)\n'
        + '    return ~(signBit | (exponent << 4) | mantissa);\n'
        + '  }\n'
        + '  \n'
        + '  // Speech-optimized pre-emphasis filter (enhances intelligibility)\n'
        + '  applyPreEmphasis(samples) {\n'
        + '    const output = new Float32Array(samples.length);\n'
        + '    for (let i = 0; i < samples.length; i++) {\n'
        + '      const current = samples[i];\n'
        + '      output[i] = current - this.preEmphasisAlpha * this.prevSample;\n'
        + '      this.prevSample = current;\n'
        + '    }\n'
        + '    return output;\n'
        + '  }\n'
        + '  \n'
        + '  // Speech-optimized automatic gain control\n'
        + '  applyAGC(samples) {\n'
        + '    // Calculate RMS level\n'
        + '    let rms = 0;\n'
        + '    for (let i = 0; i < samples.length; i++) {\n'
        + '      rms += samples[i] * samples[i];\n'
        + '    }\n'
        + '    rms = Math.sqrt(rms / samples.length);\n'
        + '    \n'
        + '    // Update AGC gain smoothly\n'
        + '    if (rms > 0.001) {  // Avoid division by zero\n'
        + '      const targetGain = this.agcTarget / rms;\n'
        + '      this.agcGain = this.agcSmoothingFactor * this.agcGain + (1 - this.agcSmoothingFactor) * targetGain;\n'
        + '      \n'
        + '      // Limit gain to prevent excessive amplification\n'
        + '      this.agcGain = Math.min(8.0, Math.max(0.125, this.agcGain));\n'
        + '    }\n'
        + '    \n'
        + '    // Apply gain\n'
        + '    const output = new Float32Array(samples.length);\n'
        + '    for (let i = 0; i < samples.length; i++) {\n'
        + '      output[i] = samples[i] * this.agcGain;\n'
        + '    }\n'
        + '    \n'
        + '    return output;\n'
        + '  }\n'
        + '  \n'
        + '  process(inputs, outputs, parameters) {\n'
        + '    const input = inputs[0];\n'
        + '    if (!input || !input[0]) return true;\n'
        + '    \n'
        + '    const inputChannel = input[0];\n'
        + '    \n'
        + '    // Step 1: Apply speech pre-emphasis (improves intelligibility)\n'
        + '    const preEmphasized = this.applyPreEmphasis(inputChannel);\n'
        + '    \n'
        + '    // Step 2: Resample directly to 8kHz with better anti-aliasing\n'
        + '    let g711Samples;\n'
        + '    if (this.needsResampling) {\n'
        + '      const ratio = this.resampleRatio;\n'
        + '      const outputLength = Math.floor(preEmphasized.length / ratio);\n'
        + '      g711Samples = new Float32Array(outputLength);\n'
        + '      \n'
        + '      // Better resampling with simple windowing\n'
        + '      for (let i = 0; i < outputLength; i++) {\n'
        + '        const pos = i * ratio;\n'
        + '        const idx = Math.floor(pos);\n'
        + '        const frac = pos - idx;\n'
        + '        \n'
        + '        // Use wider window for better anti-aliasing\n'
        + '        let sum = 0;\n'
        + '        let weight = 0;\n'
        + '        for (let j = -1; j <= 2; j++) {\n'
        + '          const sampleIdx = idx + j;\n'
        + '          if (sampleIdx >= 0 && sampleIdx < preEmphasized.length) {\n'
        + '            // Cubic interpolation weights\n'
        + '            let w = 1.0;\n'
        + '            if (j === -1) w = -frac * (1 - frac) * (2 - frac) / 6;\n'
        + '            else if (j === 0) w = (1 - frac) * (1 + frac) * (2 - frac) / 2;\n'
        + '            else if (j === 1) w = frac * (1 + frac) * (2 - frac) / 2;\n'
        + '            else if (j === 2) w = -frac * (1 - frac) * frac / 6;\n'
        + '            \n'
        + '            sum += preEmphasized[sampleIdx] * w;\n'
        + '            weight += w;\n'
        + '          }\n'
        + '        }\n'
        + '        g711Samples[i] = weight > 0 ? sum / weight : 0;\n'
        + '      }\n'
        + '    } else {\n'
        + '      g711Samples = preEmphasized;  // Already 8kHz\n'
        + '    }\n'
        + '    \n'
        + '    // Step 3: Apply speech-optimized AGC\n'
        + '    const agcSamples = this.applyAGC(g711Samples);\n'
        + '    \n'
        + '    // Step 4: Convert to G.711 μ-law with speech-optimized scaling\n'
        + '    for (let i = 0; i < agcSamples.length; i++) {\n'
        + '      // Use more conservative scaling for speech (was 36863, now ~24000)\n'
        + '      const scaledSample = Math.round(agcSamples[i] * 24000);\n'
        + '      const mulawByte = this.linearToMulaw(scaledSample);\n'
        + '      this.audioBuffer.push(mulawByte);\n'
        + '    }\n'
        + '    \n'
        + '    // Send buffer periodically (unchanged)\n'
        + '    const timeSinceLastSend = (currentTime - this.lastSentTime) * 1000;\n'
        + '    if (timeSinceLastSend >= this.sendIntervalMs && this.audioBuffer.length > 0) {\n'
        + '      const bufferToSend = new Uint8Array(this.audioBuffer);\n'
        + '      this.port.postMessage({\n'
        + '        buffer: bufferToSend.buffer,\n'
        + '        length: bufferToSend.length,\n'
        + '        timestamp: Date.now()\n'
        + '      }, [bufferToSend.buffer]);\n'
        + '      this.audioBuffer = [];\n'
        + '      this.lastSentTime = currentTime;\n'
        + '    }\n'
        + '    \n'
        + '    return true;\n'
        + '  }\n'
    + '}\n'
    + 'registerProcessor(\'simple-audio-processor\', AudioProcessor);');
};

MicrophoneController.prototype.registerSimpleAudioWorklet = function () {
  // Define a dead simple audio worklet processor
  const processorCode = this.workletProcessorCode();
  const blob = new Blob([processorCode], { type: 'application/javascript' });
  this.MicrophoneController_workletUrl_var = URL.createObjectURL(blob);
  console.log('Created advanced audio worklet URL:', this.MicrophoneController_workletUrl_var);
};

MicrophoneController.prototype.computeBufferHash = function (MicrophoneController_computeBufferHash_buffer_var) {
  // Use Web Crypto API which works in both Node.js and browsers
  const crypto = globalThis.crypto;
  if (!crypto || !crypto.subtle) {
    throw new Error('Web Crypto API not available');
  }

  // Compute SHA-256 hash
  crypto.subtle.digest('SHA-256', MicrophoneController_computeBufferHash_buffer_var).then((hashBuffer) => {
    // Convert hash to hex string
    const hashArray = [...new Uint8Array(hashBuffer)];
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    this.bus.emit('microphone', new Event.AudioHash_MicrophoneControl(this.name, 'microphone', hashHex));
  }).catch((error) => console.error(error));
};

MicrophoneController.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

MicrophoneController.prototype._delete = function () {
  this._statemachine = null;
  this._MicrophoneController_instance = null;
  this.bus.removeAllListeners();
};

MicrophoneController.prototype._init = function () {
  this._MicrophoneController_instance = new StateJS.Instance('MicrophoneController_instance', this._statemachine);
  this.ready = true;
};

MicrophoneController.prototype._receive = function (msg) {
  if (this.ready) {
    this._MicrophoneController_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

MicrophoneController.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tstartToneTimeout = ${this.MicrophoneController_startToneTimeout_var}`;
  result += `\n\tserial = ${this.MicrophoneController_serial_var}`;
  result += `\n\ttone = ${this.MicrophoneController_tone_var}`;
  result += `\n\tbufferTimeInMs = ${this.MicrophoneController_bufferTimeInMs_var}`;
  result += `\n\tworkletUrl = ${this.MicrophoneController_workletUrl_var}`;
  result += `\n\taudioProcessor = ${this.MicrophoneController_audioProcessor_var}`;
  result += `\n\ttoneGenerator = ${this.MicrophoneController_toneGenerator_var}`;
  result += `\n\tclosingToneTimeout = ${this.MicrophoneController_closingToneTimeout_var}`;
  result += `\n\tclient = ${this.MicrophoneController_client_var}`;
  result += `\n\ttoneVolume = ${this.MicrophoneController_toneVolume_var}`;
  result += `\n\tstream = ${this.MicrophoneController_stream_var}`;
  result += `\n\taudioContext = ${this.MicrophoneController_audioContext_var}`;
  result += `\n\taudioMessageBuffer = ${this.MicrophoneController_audioMessageBuffer_var}`;
  result += `\n\taudioHash = ${this.MicrophoneController_audioHash_var}`;
  result += `\n\tcameraId = ${this.MicrophoneController_cameraId_var}`;
  result += `\n\taudioSource = ${this.MicrophoneController_audioSource_var}`;
  result += `\n\tapiURL = ${this.MicrophoneController_apiURL_var}`;
  result += `\n\ttimerId = ${this.MicrophoneController_timerId_var}`;
  result += `\n\tMAX_BUFFER_SIZE = ${this.MicrophoneController_MAX_BUFFER_SIZE_var}`;
  result += `\n\tmaxRecordingTime = ${this.MicrophoneController_maxRecordingTime_var}`;
  result += '';
  return result;
};

module.exports = MicrophoneController;
